import React from "react";

const SITE_URL = "https://ajeshbs.me";

const StructuredData = () => {
    const personSchema = {
        "@context": "https://schema.org",
        "@type": "Person",
        name: "Ajesh BS",
        jobTitle: "Mechanical Engineer",
        description:
            "Innovative Mechanical Engineer specializing in Siemens NX CAD design with proven track record in design skills and end-to-end project management.",
        email: "contact@ajeshbs.me",
        url: SITE_URL,
        sameAs: [
            "https://in.linkedin.com/in/ajeshbs",
            "https://github.com/ajeshbs",
            "https://instagram.com/ajeshbs.me",
        ],
        knowsAbout: [
            "Mechanical Engineering",
            "Siemens NX",
            "CAD Design",
            "3D Modeling",
            "Product Design",
            "STL Files",
            "Project Management",
        ],
    };

    const websiteSchema = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "Ajesh BS Portfolio",
        url: SITE_URL,
        description:
            "Portfolio of Ajesh BS — Mechanical Engineer specializing in Siemens NX CAD design with 30+ interactive 3D models.",
        author: {
            "@type": "Person",
            name: "Ajesh BS",
        },
    };

    const profilePageSchema = {
        "@context": "https://schema.org",
        "@type": "ProfilePage",
        mainEntity: {
            "@type": "Person",
            name: "Ajesh BS",
            jobTitle: "Mechanical Engineer",
            url: SITE_URL,
        },
        name: "Ajesh BS - Mechanical Engineer Portfolio",
        description:
            "Professional portfolio showcasing CAD designs, engineering projects, and skills.",
    };

    const schemas = [personSchema, websiteSchema, profilePageSchema];

    return (
        <>
            {schemas.map((schema, index) => (
                <script
                    key={index}
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(schema),
                    }}
                />
            ))}
        </>
    );
};

export default StructuredData;
